import React, { useEffect, useState } from 'react';
import Banner from './Banner';
import EventsListing from '../../Common/EventsListing';
import JoinTribe from '../../Common/JoinTribe';
import FindYourTribe from '../../Common/FindYourTribe';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  addFilter,
  addFilterList,
  getAllEventCategories,
  getAllEvents,
  getAllFilterEvents,
  updateSearchQuery,
} from '../../../Redux/slices/eventSlice';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const { dashboardData, searchQuery, categories } = useSelector(
    (state) => state.event
  );
  const [category, setCategory] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCategoryChange = (value) => {
    const category = categories.find((item) => item.value === value);
    dispatch(addFilterList({ type: 'Category', value: category.text }));
    setCategory(value);
    dispatch(
      addFilter({
        startPrice: '',
        endPrice: '',
        category: value,
        date: '',
      })
    );
  };

  const handleQueryChange = (event) => {
    const { value } = event.target;
    dispatch(updateSearchQuery(value));
  };

  const searchHandler = () => {
    navigate('/events');
    dispatch(getAllFilterEvents());
  };

  useEffect(() => {
    dispatch(getAllEvents());
    dispatch(getAllEventCategories());
  }, []);

  return (
    <div className="home">
      <Banner
        handleCategoryChange={handleCategoryChange}
        handleQueryChange={handleQueryChange}
        selectedCategory={category}
        query={searchQuery}
        searchHandler={searchHandler}
      />
      <div>
        {dashboardData?.map(
          (data) =>
            (data.events?.length > 0 || data.categories?.length > 0) && (
              <EventsListing
                key={`Home-Event-List-${data.title}`}
                eventList={data}
                styleClass="listingWithCarousel"
              />
            )
        )}
        <JoinTribe />
        <FindYourTribe />
      </div>
    </div>
  );
};

export default Home;
